/* src/app/shared/components/element-blocker/element-blocker.component.scss */
.flex-center {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
.fill-height,
.white-content-page,
.white-sheet-content {
  flex: 1 0 auto;
  display: flex;
  flex-direction: column;
  align-items: stretch;
  justify-content: flex-start;
  align-content: stretch;
}
.page-center,
.white-content-page .ups-content-block,
.white-content-page .ups-page-header,
.white-sheet-content {
  min-width: 21.5rem;
  max-width: 71.875rem;
  width: 100%;
  margin: 0 auto;
}
.white-sheet-content {
  background-color: white;
}
.white-sheet-content .ups-page-header {
  padding: 1.125rem 23px;
}
@media screen and (min-width: 48rem) {
  .white-sheet-content .ups-page-header {
    padding: 2.625rem 2rem;
  }
}
.white-content-page {
  background-color: white;
  min-height: 100%;
}
.white-content-page .ups-page-header {
  padding-bottom: 1em;
  min-width: auto;
}
.white-content-page .ups-content-block {
  padding: 0 2rem 2em;
}
.element-blocker {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  font-size: 0.8em;
  width: 100%;
  height: 100%;
  background-color: rgba(255, 255, 255, 0.75);
  z-index: 9;
}
.element-blocker.light {
  background-color: rgba(255, 255, 255, 0.75);
}
.element-blocker.dark {
  background-color: rgba(16, 16, 16, 0.3);
}
.element-blocker.page {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  overflow: hidden;
  background: rgba(16, 16, 16, 0.3) !important;
  z-index: 99;
}
.element-blocker.page .mat-mdc-progress-spinner {
  width: 7em !important;
  height: 7em !important;
}
.element-blocker .mat-mdc-progress-spinner {
  width: 2.5rem !important;
  height: 2.5rem !important;
}
.element-blocker ::ng-deep svg circle {
  stroke-width: 4px !important;
}
:host {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 9999;
}
/*# sourceMappingURL=element-blocker.component.css.map */
